//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import { createRefetchContainer } from "react-relay";
// suggestion-body-low-focus-time imports
import { IProps, IContainer, IState } from "./SuggestionBodyLowFocusTime.d";
import {
  suggestionBodyLowFocusTimeFragments,
  refetchQuery,
} from "./SuggestionBodyLowFocusTime.gql";
import * as s from "./SuggestionBodyLowFocusTime.styles";
// util
import { GOAL_MINUTES } from "@util/team-health.util";
// other-components
import { H3 } from "@ui";
import { AvatarPerson } from "@components/avatar";
import { FocusTimeMeter } from "@components/focus-time-meter";

//////////////////
// COMPONENT
//////////////////
class SuggestionBodyLowFocusTimeCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      person: null,
    };
  }

  public componentDidMount() {
    // load persons for avatars
    this.props.relay.refetch(
      {
        calendarIds: [this.props.suggestionPayload.calendarId],
        orgRelayId: this.props.org.id,
      },
      undefined,
      () => {
        if (
          this.props.org.personsByCalendarIdsErrorable.__typename === "PersonList" &&
          this.props.org.personsByCalendarIdsErrorable.list.length
        ) {
          const person = this.props.org.personsByCalendarIdsErrorable.list[0];
          this.setState({ person });
        }
      },
    );
  }

  private getName = (calId: string, userProfile?: ISchema.IUserProfile | null) => {
    if (!!userProfile && !!userProfile.familyName && !!userProfile.givenName) {
      return `${userProfile.givenName} ${userProfile.familyName}`;
    } else if (!!userProfile && !!userProfile.givenName) {
      return `${userProfile.givenName}`;
    } else {
      return calId;
    }
  };

  public render() {
    const { suggestionPayload, org } = this.props;
    const { calendarId, totalFocusTimeMinutes, totalMinutes } = suggestionPayload;
    const { person } = this.state;

    const name = this.getName(calendarId, (person && person.profile) || null);

    return (
      <div style={s.container}>
        <div style={s.header}>
          <AvatarPerson
            org={org}
            person={person}
            orgPerson={null}
            size={35}
            backupCalendarId={suggestionPayload.calendarId}
            parentName={"SuggestionBodyLowFocusTime"}
          />
          <H3 style={s.h3}>{name}</H3>
        </div>
        <FocusTimeMeter
          busyMinutes={0}
          focusMinutes={totalFocusTimeMinutes}
          totalMinutes={totalMinutes}
          goalMinutes={GOAL_MINUTES}
          crawledStatus={"Synced" as ISchema.CrawledStatus}
        />
      </div>
    );
  }
}

//////////////////
// RELAY
//////////////////
export const SuggestionBodyLowFocusTime = createRefetchContainer<IContainer>(
  SuggestionBodyLowFocusTimeCmpt,
  suggestionBodyLowFocusTimeFragments,
  refetchQuery,
);
